import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dangerouslySetGlyph"];
import React, { memo } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import LegacyIcon from './icon';
var sizesEligibleForNewIcons = ['small', 'medium'];

/**
 * `IconFacade` is a component that conditionally renders either a new or legacy icon based on a feature flag.
 *
 * @param {IconFacadeProps} props - The props for the IconFacade component. Includes properties for configuring
 * the icon such as `size`, `spacing`, `primaryColor`, `iconType`, and potentially others depending on the icon.
 * `dangerouslySetGlyph` is a prop specific to the legacy icon component for setting the icon glyph directly.
 * @returns A React element representing either the new or legacy icon based on the feature flag and icon size.
 */
export var IconFacade = /*#__PURE__*/memo(function IconFacade(_ref) {
  var _props$size;
  var dangerouslySetGlyph = _ref.dangerouslySetGlyph,
    props = _objectWithoutProperties(_ref, _excluded);
  var NewIcon = props.newIcon;

  // By default, the icon size will be medium and spacing will be none for small icons
  var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
  var spacing = size === 'small' ? 'none' : 'spacious';
  var useNewIcon = !props.isFacadeDisabled &&
  // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
  fg('platform-visual-refresh-icons-legacy-facade') && sizesEligibleForNewIcons.includes(size);
  if (useNewIcon && NewIcon) {
    return /*#__PURE__*/React.createElement(NewIcon, _extends({}, props, {
      spacing: spacing,
      color: props.primaryColor || 'currentColor',
      type: props.iconType
    }));
  }
  return /*#__PURE__*/React.createElement(LegacyIcon, _extends({
    dangerouslySetGlyph: dangerouslySetGlyph
  }, props));
});
export default IconFacade;